<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>News & Events</span>
        <b>→</b> <span>Conference-News</span> <b>→</b>
        <span>Content</span>
      </div>
      <div v-for="(item, index) in news_list" :key="index">
        <div class="box">
          <div class="box-title">{{ item.news_title_en }}</div>
          <!--div class="box-img">
            <img :src="item.image_url" alt="" />
          </！div-->
          <div class="text">
            <div v-html="item.news_content_en"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      news_id: "",
      news_list: [],
    };
  },
  mounted() {
    this.news_id = this.$route.query.news_id;
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      this.$http
        .news_list({
          news_id: this.news_id,
        })
        .then((res) => {
          this.news_list = res.data;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .small-title {
    margin: 25px 0;
    font-weight: 600;
  }

  .card {
    padding: 25px 15px;
    box-sizing: border-box;
    position: relative;
    font-weight: 700;
    line-height: 1.9;
    background-color: hsla(0, 0%, 50.2%, 0.05);

    .card-title {
      color: #5b965a;
      margin-bottom: 20px;
    }

    img {
      position: absolute;
      bottom: 30px;
      right: 35px;
      width: 35%;
      height: auto;
    }

    .right {
      position: absolute;
      bottom: 30px;
      right: 35px;
      width: 35%;
      height: auto;
    }
  }

  .box {
    padding: 0 100px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .text-green {
    color: #5b965a;
  }

  .title {
    position: relative;
    color: #5b965a;
    padding-bottom: 10px;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 380px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    //color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 22px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;
  }

  .box-img {
    text-align: center;
  }

  .box-img img {
    width: 60%;
    height: auto;
    margin-bottom: 30px;
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConferenceNewsContent.vue